import { useParams } from 'react-router-dom';
import BaseOrientationCheckout from './BaseOrientationCheckout';

const CommerceOrientationCheckout = () => {
    const { uuid } = useParams<{ uuid: string }>();
    return (
        <BaseOrientationCheckout
            //eventUuid={uuid || ''} //------------------------------------------------------------------ Temporary put back after
            primaryColor="#6D2C3D" // Burgundy/Maroon
            secondaryColor="#c4a86f" // Gold/Tan
            gradientFrom="from-[#6D2C3D]" // Dark Maroon (from logo)
            gradientTo="to-[#85384c]"   // Slightly lighter maroon
            logoUrl="/branding/orientation/smith-logo.jpg"
            customDateText="September 6 - 13, 2026"
            customLinks={[
                // {
                //     alias: "Commerce Resources",
                //     url: "https://www.smithcommerceoweek.com/"
                // },
                // {
                //     alias: "Program Guide",
                //     url: "https://www.smithcommerceoweek.com/"
                // },
                // {
                //     alias: "Student Services",
                //     url: "https://www.smithcommerceoweek.com/"
                // }
            ]}
            customStyles={{
                headerBg: 'bg-[#c4a86f]/20', // Soft gold background
                cardBg: 'bg-white',
                buttonGradient: 'linear-gradient(to right, #6D2C3D, #c4a86f)',
                buttonHoverGradient: 'linear-gradient(to right, #6D2C3D, #d4b87f)',
                tagBg: 'bg-[#6D2C3D] text-white', // Burgundy tags
            }}
            ticketsBadgeClass="bg-[#c4a86f] text-[#6D2C3D]"
            logoSize={200}
            cropLogoToCircle={true}
            hidePhoneNumber={true}
            customBursaryInstructions="The Fall Orientation Bursary/Fee Waiver Program helps Commerce students cover costs associated with Orientation. By checking 'Request financial assistance (bursary)', your application will be reviewed by the Commerce Office and assessed by Queen's Financial Aid. The Financial Aid Office determines eligibility based on financial need.

    The Commerce Executive on Orientation does not assess or have access to students' financial aid information. Successful applicants will be notified of the outcome of their application, and refunds will be issued to the original method of payment at least 7 days before September 6th , 2026 (the first day of Fall Orientation).

    If you are not able to pay the Orientation fee up front, please email orientation@comsoc.queensu.ca, and we will do our best to assist you.

        <b>Applications must be received BEFORE August 4th, 2026 @11:59 PM EST to be eligible for consideration.</b>
        "
            hideTicketsAvailable={true}
            requiredEmailDomain="@queensu.ca"
            eventUuid='71c86142-9a4c-46de-bf30-f41db9570b9b' // ---------------------------------------------------------------------------- TEMPORARY
        />
    );
};

export default CommerceOrientationCheckout; 